import Icon, { IconType } from 'components/Icon';
import ColorButton from 'components/Widget/Button/ColorButton';
import * as S from './styles';

export interface CreditTileButton {
	label: string;
	onClick: () => void;
	icon?: IconType;
}

interface CreditTileProps {
	icon: IconType;
	iconColor: string;
	label: string;
	amount: string;
	subtext?: string;
	button?: CreditTileButton;
	highlight?: boolean;
}

const CreditTile = ({
	icon,
	iconColor,
	label,
	amount,
	subtext,
	button,
	highlight,
}: CreditTileProps) => {
	return (
		<S.Base $highlight={highlight}>
			<S.Header>
				<S.Icon $iconColor={iconColor}>
					<Icon type={icon} width={18} height={18} color={iconColor} />
				</S.Icon>
				<S.Label>{label}</S.Label>
			</S.Header>
			<S.Amount>{amount}</S.Amount>
			{subtext && <S.Subtext>{subtext}</S.Subtext>}
			{button && (
				<S.ButtonWrapper>
					<ColorButton
						label={button.label}
						icon={button.icon}
						onClick={button.onClick}
						fullWidth
					/>
				</S.ButtonWrapper>
			)}
		</S.Base>
	);
};

export default CreditTile;
